import * as React from "react"
const IconBuildingTenant = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill="none"
        {...props}
    >
        <path
            stroke="#6C6C82"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.2}
            d="M2 14h12M6 5.333h.667M6 8h.667M6 10.667h.667m2.666-5.334H10M9.333 8H10m-.667 2.667H10M3.333 14V3.333A1.333 1.333 0 0 1 4.667 2h6.666a1.333 1.333 0 0 1 1.334 1.333V14"
        />
    </svg>
)
export default IconBuildingTenant
